if (!customElements.get('dope-media-library')) {
  customElements.define('dope-media-library', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const on = (el, event, fn) => el?.addEventListener(event, fn, { signal });
      const rail = this.querySelector('[data-media-rail]');
      const cards = [...this.querySelectorAll('[data-media-card]')];
      const dialog = this.querySelector('[data-media-dialog]');
      const viewer = this.querySelector('[data-media-viewer]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const hover = matchMedia('(hover: hover) and (pointer: fine)');
      const pausePreviews = () => this.querySelectorAll('[data-preview-src]').forEach(video => { video.pause(); video.classList.remove('is-playing'); });
      let selected = 0;
      let opener;
      const render = (index) => {
        selected = index;
        viewer.querySelector('video')?.pause();
        viewer.replaceChildren(cards[index].querySelector('template').content.cloneNode(true));
        dialog.setAttribute('aria-label', cards[index].querySelector('[data-media-title]').textContent.trim());
        this.querySelector('[data-media-position]').textContent = `${index + 1} / ${cards.length}`;
        this.querySelector('[data-media-prev]').disabled = index === 0;
        this.querySelector('[data-media-next]').disabled = index === cards.length - 1;
        viewer.querySelector('video')?.play().catch(() => {});
      };
      cards.forEach((card, index) => {
        const trigger = card.querySelector('[data-media-trigger]');
        const video = card.querySelector('[data-preview-src]');
        on(trigger, 'click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          pausePreviews();
          opener = trigger;
          render(index);
          dialog.showModal();
        });
        on(trigger, 'pointerenter', async () => {
          if (!video || !hover.matches || reduced.matches || navigator.connection?.saveData || dialog.open) return;
          pausePreviews();
          if (!video.getAttribute('src') && !video.querySelector('source[src]')) video.src = video.dataset.previewSrc;
          try { await video.play(); if (!trigger.matches(':hover')) video.pause(); else video.classList.add('is-playing'); } catch {}
        });
        on(trigger, 'pointerleave', () => { video?.pause(); video?.classList.remove('is-playing'); });
      });
      on(this.querySelector('[data-media-close]'), 'click', () => dialog.close());
      on(dialog, 'click', (event) => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
      on(dialog, 'close', () => { viewer.querySelector('video')?.pause(); viewer.replaceChildren(); opener?.focus(); });
      on(this.querySelector('[data-media-prev]'), 'click', () => { if (selected > 0) render(selected - 1); });
      on(this.querySelector('[data-media-next]'), 'click', () => { if (selected < cards.length - 1) render(selected + 1); });
      on(dialog, 'keydown', (event) => {
        if (event.target.closest('video')) return;
        if (event.key === 'ArrowLeft' && selected > 0) { event.preventDefault(); render(selected - 1); }
        if (event.key === 'ArrowRight' && selected < cards.length - 1) { event.preventDefault(); render(selected + 1); }
      });
      const updateArrows = () => {
        this.querySelector('[data-rail-prev]').disabled = rail.scrollLeft < 2;
        this.querySelector('[data-rail-next]').disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };
      on(this.querySelector('[data-rail-prev]'), 'click', () => rail.scrollBy({ left: -rail.clientWidth * .75, behavior: reduced.matches ? 'instant' : 'smooth' }));
      on(this.querySelector('[data-rail-next]'), 'click', () => rail.scrollBy({ left: rail.clientWidth * .75, behavior: reduced.matches ? 'instant' : 'smooth' }));
      on(rail, 'scroll', updateArrows);
      this.resize = new ResizeObserver(updateArrows);
      this.resize.observe(rail);
      this.querySelector('[data-rail-controls]').hidden = false;
      updateArrows();
      this.observer = new IntersectionObserver((entries) => entries.forEach(entry => { if (!entry.isIntersecting) { entry.target.pause(); entry.target.classList.remove('is-playing'); } }), { threshold: .25 });
      this.querySelectorAll('[data-preview-src]').forEach(video => this.observer.observe(video));
      on(document, 'visibilitychange', () => { if (document.hidden) { pausePreviews(); viewer.querySelector('video')?.pause(); } });
      on(reduced, 'change', pausePreviews);
    }
    disconnectedCallback() {
      this.querySelectorAll('video').forEach(video => video.pause());
      this.querySelector('dialog')?.close();
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
    }
  });
}
